exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".osv-alert-message{padding:1em 1.5em 1em 1.5em;border-left-style:solid;border-width:4px;border-radius:4px;margin-bottom:1em}.osv-alert-message.single-message{text-align:center}.osv-alert-message.multi-messages{text-align:left}.osv-alert-message.warning{color:#947600;border-color:#ffdd57;background-color:#fffbeb}.osv-alert-message.danger{color:#cc0f35;border-color:#f14668;background-color:#feecf0}.osv-alert-message.success{color:#257942;border-color:#48c774;background-color:#effaf3}.osv-alert-message.info{color:#1d72aa;border-color:#3298dc;background-color:#eef6fc}", ""]);

// exports
